import { createContext, useContext, useState, useEffect } from "react";
import { copy } from "@/i18n/copy";

const LangContext = createContext({ lang: "pt", setLang: () => {}, t: copy.pt });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "pt";
    return window.localStorage.getItem("ordo-lang") || "pt";
  });

  useEffect(() => {
    window.localStorage.setItem("ordo-lang", lang);
    document.documentElement.lang = lang === "pt" ? "pt-PT" : "en";
  }, [lang]);

  const value = { lang, setLang, t: copy[lang] };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
